import script from "./DeviceTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./DeviceTemplate.vue?vue&type=script&setup=true&lang=js"

import "./DeviceTemplate.vue?vue&type=style&index=0&id=8cded210&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8cded210"]])

export default __exports__